import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PathNames } from 'constants/General'
import { setAuthCookies } from 'utils/utils'
import { getBase64DecodeToString, getDecodedToken, TOKEN_PARAM } from '../utils'

const useAuthRedirect = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const token = searchParams.get(TOKEN_PARAM)

  useEffect(() => {
    if (token) {
      const tokenString = getBase64DecodeToString(token)
      setSearchParams('')

      if (tokenString) {
        const [access_token, secret] = getDecodedToken(tokenString)
        if (access_token && secret) {
          try {
            setAuthCookies({ access_token, secret })
            navigate(PathNames.DASHBOARD)
          } catch (error) {
            console.error('Error: Auth Cookie setting', error)
          }
        }
      }
    }
  }, [token])

  return token
}

export default useAuthRedirect
